/* eslint-disable eol-last */
// eslint-disable-next-line import/prefer-default-export
export const EmptyDataMessage = 'Please complete the data';

export const DonationType = [
  { value: 1, label: 'Infaq' },
  { value: 2, label: 'Patronage' },
  { value: 3, label: 'Zakat' },
  { value: 4, label: 'Qurban' },
  { value: 5, label: 'Sedekah' },
];

export const DonationSubType = [
  { value: 1, label: 'Zakat Penghasilan' },
  { value: 2, label: 'Zakat Maal' },
];

export const volunteerOptions = [
  { value: 'Dzikra', label: 'Dzikra' },
  { value: 'Inovasi 360', label: 'Inovasi 360' },
  { value: 'rumah_zakat', label: 'Rumah Zakat' },
  { value: 'DT Peduli', label: 'DT Peduli' },
  { value: 'zakat_sukses', label: 'Zakat Sukses' },
  { value: 'dompet_dhuafa', label: 'Dompet Dhuafa' },
  { value: 'mizan_amanah', label: 'Mizan Amanah' },
  { value: 'ydsf', label: 'Yayasan Dana Sosial Al Falah' },
  { value: 'bmh', label: 'Baitul Maal Hidayatullah' },
  { value: 'mitra_yatim', label: 'Mitra Yatim' },
  { value: 'baznas', label: 'BAZNAS' },
  { value: 'bm_rumah_baik', label: 'Baitul Maal Rumah Baik' },
  { value: 'darul_hikam', label: 'Darul Hikam' },
];